<diV>
  <div class="actions">
    <div *ngIf="this.data.input.command.name == 'PrintFormCommand'">
      <mat-list>
        <mat-list-item>
          <button mat-menu-item
                  (click)="onPrint('L')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Document 1 (left panel)</span>
          </button>
        </mat-list-item>
        <mat-list-item>
          <button mat-menu-item
                  (click)="onPrint('R')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Document 2 (right panel)</span>
          </button>
        </mat-list-item>

        <mat-list-item>
          <button mat-menu-item
                  (click)="onPrint('B')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Both documents side by side</span>
          </button>
        </mat-list-item>
      </mat-list>
    </div>
    <div *ngIf="this.data.input.command.name == 'DownloadFormCommand'">
      <mat-list>
        <mat-list-item>
          <button mat-menu-item
                  (click)="onDownload('L')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Document 1 (left panel)</span>
          </button>
        </mat-list-item>
        <mat-list-item>
          <button mat-menu-item
                  (click)="onDownload('R')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Document 2 (right panel)</span>
          </button>
        </mat-list-item>
<!--        <mat-list-item>
          <button mat-menu-item
                  (click)="onDownload('B')"
                  particleAnalytics
                  analyticsCategory="action-type-cell-viewer"
                  analyticsAction="action-dropdown"
                  analyticsName="action">
            <span>Both documents side by side</span>
          </button>
        </mat-list-item>-->
      </mat-list>
    </div>
  </div>
</diV>
